// Module
var code = "<div id=\"menu\"></div> ";
// Exports
module.exports = code;